import { useEffect, useRef } from 'react';
import { CalendarClock } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

export const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL || 'https://calendly.com/duliptech';

export default function CalendlyEmbed() {
  const { t } = useLang();
  const loaded = useRef(false);

  useEffect(() => {
    if (!CALENDLY_URL || loaded.current) return;
    loaded.current = true;
    if (!document.querySelector('script[src*="calendly.com/assets/external/widget.js"]')) {
      const s = document.createElement('script');
      s.src = 'https://assets.calendly.com/assets/external/widget.js';
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  if (!CALENDLY_URL) {
    return (
      <div className="rounded-2xl border border-dashed border-[#10282C]/20 bg-white/60 p-10 text-center" data-testid="demo-booking-placeholder">
        <CalendarClock size={30} className="mx-auto text-[#10282C]/35" strokeWidth={1.5} />
        <p className="mt-4 text-[13px] text-[#10282C]/45 max-w-sm mx-auto">{t('contactPage.demoSub')}</p>
      </div>
    );
  }

  return (
    <div className="rounded-2xl bg-white border border-[#10282C]/8 overflow-hidden shadow-[0_24px_60px_-30px_rgba(16,40,44,0.2)]" data-testid="demo-booking-calendly">
      <div
        className="calendly-inline-widget"
        data-url={`${CALENDLY_URL}?hide_gdpr_banner=1&primary_color=00918f`}
        style={{ minWidth: '320px', height: '660px' }}
      />
    </div>
  );
}
